import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'
import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, Icon, SlideFade, Text } from '@chakra-ui/react'

interface AiOperatorNoCriteriaBannerIProps {
  hasNoCriterion: boolean
  message?: string
}
export const AiOperatorNoCriteriaBanner = ({
  hasNoCriterion,
  message,
}: AiOperatorNoCriteriaBannerIProps) => {
  const { t } = useTranslation()
  const mode = useLightMode()

  return (
    <SlideFade in={hasNoCriterion}>
      <Alert borderRadius='xl' mb={4} px={4} status='error' width='100%'>
        <Icon
          as={HiOutlineInformationCircle}
          boxSize='20px'
          color={`text.alert-danger.${mode}`}
          mr='10px'
        />
        <Text
          color={`text.alert-danger.${mode}`}
          fontSize='sm'
          fontWeight='medium'
        >
          {message ?? t('automations:no_criteria_banner_default_message')}
        </Text>
      </Alert>
    </SlideFade>
  )
}
